export const environment = {
  production: true,
  buildId: '2516438501317441',
  configFile: 'config.json',
};
